import { createScreen, waitForFont } from '@/engine/canvas';
import { startLoop } from '@/engine/loop';
import { Game } from '@/game/game';
import { bindGameFocus } from '@/game/focus';
import { mountTouchControls } from '@/game/touch';
import { Stats } from '@/engine/stats';

async function main() {
  await waitForFont();
  const root = document.getElementById('root')!;
  const screen = createScreen(root);
  const params = new URLSearchParams(location.search);
  let seed = Number(params.get('seed') ?? Date.now() % 100000);
  // an existing save fixes the seed so the same mansion is rebuilt
  if (!params.get('seed')) {
    try {
      const raw = localStorage.getItem('homehomehome.save.v1');
      if (raw) seed = JSON.parse(raw).seed ?? seed;
    } catch { /* ignore */ }
  }
  const game = new Game(screen, seed);
  (window as unknown as { game: Game }).game = game;
  bindGameFocus(game);
  const touch = mountTouchControls(game, screen.display, screen.toInternal);
  const stats = params.has('stats') ? new Stats() : null;
  let updateMs = 0, lastFrame = performance.now();
  startLoop(
    (dt) => {
      const t = performance.now();
      game.update(dt);
      updateMs += performance.now() - t;
    },
    (alpha) => {
      const t0 = performance.now();
      game.render(alpha);
      const t1 = performance.now();
      screen.present();
      touch.current?.update();
      const t2 = performance.now();
      if (stats) { stats.push({ update: updateMs, render: t1 - t0, present: t2 - t1, frame: t2 - lastFrame }); }
      updateMs = 0; lastFrame = t2;
    },
  );
}

main().catch((e) => {
  document.body.innerHTML = `<pre style="color:#f88;padding:20px;font:14px monospace">${String(e?.stack ?? e)}</pre>`;
  console.error(e);
});
